import { useState, useEffect } from "react";
import {
    DataGridPremium,
    GridToolbarContainer,
    GridToolbarExport,
} from "@mui/x-data-grid-premium";
import { useNavigate } from "react-router";
import classes from "./SoloChallengeDetails.module.css";
import { toast } from "react-toastify";
import ARENO_API_ENDPOINT from "../../../api";
import AUTH_CONTEXT from "../../../store";
import { StatusCode } from "../../../utils";
import Loader from "../../../components/Loader/Loader";
import { BASE_PATH_TO_SOLO_CHALLENGE_ATTEMPTS, BASE_PATH_TO_SOLO_CHALLENGE_DETAILS } from "../../../base_routes_paths/challenge_paths";
import { BASE_PATH_TO_USER_DETAILS, BASE_PATH_TO_USER_SNAPSHOTS } from "../../../base_routes_paths/data_paths";

const SoloChallengeParticipants = () => {
    const { token, fileName } = AUTH_CONTEXT()
    const EXPORT_FILENAME = `${fileName}_SoloChallengeParticipants`;
    const userColumns = [
        {
            field: "UserID",
            headerName: "UserID",
            width: 230,
            renderCell: (params) => {
                return (
                    <a target="_blank" rel="noreferrer" href={`${BASE_PATH_TO_USER_DETAILS}/` + params.row.UserID}>{params.row.UserID}</a>
                );
            },
        },
        {
            field: "ChallengeID",
            headerName: "Challenege ID",
            width: 230,
            renderCell: (params) => {
                return (
                    <a target="_blank" rel="noreferrer" href={`${BASE_PATH_TO_SOLO_CHALLENGE_DETAILS}/` + params.row.ChallengeID}>{params.row.ChallengeID}</a>
                );
            },
        },
        {
            field: "WorkoutID",
            headerName: "WorkoutID",
            width: 130,
            renderCell: (params) => {
                const getWorkoutName = (number) => {
                    switch (number) {
                        case 1:
                            return 'Push-ups';
                        case 2:
                            return 'Planks';
                        case 3:
                            return 'Squats';
                        case 4:
                            return 'High Knees';
                        case 5:
                            return 'Lunges';
                        case 6:
                            return 'Situps';
                        case 7:
                            return 'Knee Pushups';
                        case 8:
                            return 'Jumping Jacks';
                        default:
                            return 'Unknown Workout';
                    }
                }
                return <>{`${getWorkoutName(params.row.WorkoutID)} (${params.row.WorkoutID})`}</>
            }
        },
        {
            field: "RegistrationID",
            headerName: "RegistrationID",
            width: 230,
        },
        {
            field: "Level",
            headerName: "Level",
            width: 80,
        },
        {
            field: "TotalCount",
            headerName: "TotalCount",
            width: 120,
        },
        {
            field: "IsSuccess",
            headerName: "IsSuccess",
            width: 120,
        },
        {
            field: "IsTimeOverForChallenge",
            headerName: "IsTimeOverForChallenge",
            width: 230,
        },
        {
            field: "StartDate",
            headerName: "StartsTimeUtc",
            width: 220,
        },
        {
            field: "Start_Date",
            headerName: "StartDate",
            width: 120,
        },
        {
            field: "Start_Time",
            headerName: "StartTime",
            width: 120,
        },
        {
            field: "EndDate",
            headerName: "EndTimeUtc",
            width: 220,
        },
        {
            field: "End_Date",
            headerName: "EndDate",
            width: 120,
        },
        {
            field: "End_Time",
            headerName: "EndTime",
            width: 120,
        },
        {
            field: "Attempts",
            headerName: "Attempts",
            width: 100,
            renderCell: (params) => {
                return (
                    <div className={classes.cellAction}>
                        <a target="_blank" rel="noreferrer" href={
                            BASE_PATH_TO_SOLO_CHALLENGE_ATTEMPTS + "/" +
                            params.row.UserID +
                            "/" +
                            params.row.ChallengeID
                        }
                            style={{ textDecoration: "none" }}
                        >
                            <div className={classes.viewButton}>Attempts</div>
                        </a>
                    </div >
                );
            },
        },
        {
            field: "snapshots",
            headerName: "Snapshots",
            width: 100,
            renderCell: (params) => {
                return (
                    <div className={classes.cellAction}>
                        <a target="_blank" rel="noreferrer" href={
                            BASE_PATH_TO_USER_SNAPSHOTS +
                            "/"
                            +
                            params.row.UserID +
                            "/" +
                            params.row.ChallengeID
                        }
                            style={{ textDecoration: "none" }}
                        >
                            <div className={classes.viewButton}>View</div>
                        </a>
                    </div>
                );
            },
        },
    ];

    const [isLoading, setIsLoading] = useState(false);
    const [isDataFetched, setIsDataFetched] = useState(false);
    let ChallengeData = [];
    const [data, setData] = useState(ChallengeData);
    const navigate = useNavigate();

    const FetchResponseGetAllUserDetails = async () => {
        try {
            let response = await fetch(
                `${ARENO_API_ENDPOINT}/challenges/AdminGetAllSoloChallengeUserDetails?TimeOffSet=${localStorage.getItem("TimeOffSet")}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${token}`,
                    },
                }
            );

            setIsLoading(false);
            StatusCode(response, navigate);
            response = await response.json();
            setIsLoading(true);
            setIsDataFetched(true);
            toast.success("Data fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return response.data;
        } catch (e) {
            setIsLoading(false);
            setIsDataFetched(false);
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        const Item = localStorage.getItem("ChallengeID");
        if (Item) {
            FetchResponseGetAllUserDetails()
                .then((result) => {
                    const filteredData = result.filter((item) => item.ChallengeID === Item);
                    let input = filteredData.map(({ _id: id, ...result }) => ({
                        id,
                        ...result,
                    }));
                    setData(input);
                    setIsLoading(true);
                    setIsDataFetched(true);
                    localStorage.removeItem("ChallengeID")
                    toast.success("Data fetched successfully!!", {
                        position: "bottom-left",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                })
                .catch((err) => console.log(err));
        } else {
            if (!isDataFetched) {
                FetchResponseGetAllUserDetails()
                    .then((result) => {
                        let input = result.map(({ _id: id, ...result }) => ({
                            id,
                            ...result,
                        }));
                        setData(input);
                        setIsLoading(true);
                        setIsDataFetched(true);
                        localStorage.removeItem("ChallengeID")
                        toast.success("Data fetched successfully!!", {
                            position: "bottom-left",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    })
                    .catch((err) => console.log(err));
            }
        }
    }, []);


    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    csvOptions={{ fileName: EXPORT_FILENAME }}
                    excelOptions={{ fileName: EXPORT_FILENAME }}
                />
            </GridToolbarContainer>
        );
    }

    return (
        <div className={classes.datatable}>
            {isLoading && (
                <DataGridPremium
                    rows={data}
                    columns={userColumns}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                    pagination
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 25, page: 0 },
                        },
                    }}
                    disableRowSelectionOnClick
                    checkboxSelection
                />
            )}
            {!isLoading && <Loader />}
        </div>
    );
};

export default SoloChallengeParticipants;
